<div class="form-panel-container">
    <form [formGroup]="formGroup">
        <div class="form-container" [ngClass]="{ readonly: _context?.mode === FormMode.Reading }">
            <div class="form-item form-item-help">
                <mat-form-field class="with-info-icon">
                    <mat-label>Nom</mat-label>
                    <input matInput data-input-lastName type="text" formControlName="lastName" autocomplete="off" required />
                </mat-form-field>
                <fa-icon [icon]="faCircleInfo" class="info-icon" matTooltip="TODO Nom" matTooltipPosition="right"></fa-icon>
            </div>

            <div class="form-item form-item-help">
                <mat-form-field class="with-info-icon">
                    <mat-label>Prénom</mat-label>
                    <input matInput data-input-firstName type="text" formControlName="firstName" autocomplete="off" required />
                </mat-form-field>
                <fa-icon [icon]="faCircleInfo" class="info-icon" matTooltip="TODO Prénom" matTooltipPosition="right"></fa-icon>
            </div>

            <div class="form-item form-item-help">
                <mat-form-field class="with-info-icon">
                    <mat-label>Email</mat-label>
                    <input matInput data-input-email type="text" formControlName="email" autocomplete="off" required />
                    @if (formGroupErrors?.email?.required && (formGroup.controls['email']?.dirty || formGroup.controls['email'].touched)) {
                        <mat-error data-input-title-error>Le champ 'Email' est obligatoire</mat-error>
                    }
                </mat-form-field>
                <fa-icon [icon]="faCircleInfo" class="info-icon" matTooltip="TODO Email" matTooltipPosition="right"></fa-icon>
            </div>

            <div class="form-item form-item-help">
                <mat-form-field class="with-info-icon">
                    <mat-label>Mobile</mat-label>
                    <input matInput data-input-email type="text" formControlName="mobileNumber" autocomplete="off" />
                </mat-form-field>
                <fa-icon [icon]="faCircleInfo" class="info-icon" matTooltip="TODO Mobile" matTooltipPosition="right"></fa-icon>
            </div>

            <div class="form-item form-item-help">
                <mat-form-field class="with-info-icon">
                    <mat-label>Société</mat-label>
                    <input matInput data-input-companyName type="text" formControlName="companyName" autocomplete="off" required />
                </mat-form-field>
                <fa-icon [icon]="faCircleInfo" class="info-icon" matTooltip="TODO Société" matTooltipPosition="right"></fa-icon>
            </div>
        </div>
    </form>
    <div class="buttons-container">
        <button mat-stroked-button class="accent-button" [disabled]="formGroup.disabled" [ngClass]="{ disabled: formGroup.invalid || formGroup.disabled }" (click)="cancel()">
            Annuler
        </button>
        <button
            mat-raised-button
            class="accent-button"
            [disabled]="formGroup.disabled || formGroup.invalid"
            [ngClass]="{ disabled: formGroup.invalid || formGroup.disabled }"
            (click)="manualSave()">
            Enregistrer
        </button>
    </div>
</div>
